import React from 'react';
import { GameType } from '../types';

interface GameControlsProps {
  onStartGame: (gameType: GameType, cheatMode?: boolean) => void;
  onResetGame: () => void;
  isGameActive: boolean;
}

const gameTypeLabels: Record<GameType, string> = {
  [GameType.NAME_MATCH]: '日英名称マッチング',
  [GameType.INNERVATION]: '神経支配',
  [GameType.BLOOD_SUPPLY]: '血液供給',
  [GameType.INNERVATION_OR_BLOOD]: '神経支配・血液供給',
  [GameType.ORIGIN_INSERTION]: '起始・停止'
};

export const GameControls: React.FC<GameControlsProps> = ({
  onStartGame,
  onResetGame,
  isGameActive
}) => {
  const [selectedGameType, setSelectedGameType] = React.useState<GameType | null>(null);

  const handleGameTypeSelect = (gameType: GameType) => {
    setSelectedGameType(gameType);
  };

  const handleModeSelect = (cheatMode: boolean) => {
    if (selectedGameType) {
      onStartGame(selectedGameType, cheatMode);
      setSelectedGameType(null);
    }
  };

  const handleBack = () => {
    setSelectedGameType(null);
  };

  return (
    <div className="game-controls">
      <h1>解剖用語カードゲーム</h1>
      
      {!isGameActive ? (
        <>
          {!selectedGameType ? (
            <div className="game-type-selection">
              <h2>ゲームタイプを選択してください</h2>
              <div className="game-type-grid">
                {Object.entries(gameTypeLabels).map(([type, label]) => (
                  <button
                    key={type}
                    className="game-type-button"
                    onClick={() => handleGameTypeSelect(type as GameType)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div className="mode-selection">
              <h2>{gameTypeLabels[selectedGameType]}</h2>
              <h3>モードを選択してください</h3>
              <div className="mode-buttons">
                <button
                  className="mode-button serious-mode"
                  onClick={() => handleModeSelect(false)}
                >
                  <div className="mode-title">本気モード</div>
                  <div className="mode-description">正解のヒントなし</div>
                </button>
                <button
                  className="mode-button cheat-mode"
                  onClick={() => handleModeSelect(true)}
                >
                  <div className="mode-title">チートモード</div>
                  <div className="mode-description">正解が緑色でハイライト</div>
                </button>
              </div>
              <button className="back-button" onClick={handleBack}>
                戻る
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="game-actions">
          <button className="reset-button" onClick={onResetGame}>
            ゲームをリセット
          </button>
        </div>
      )}
    </div>
  );
};